// extracted by mini-css-extract-plugin
export var defaultBadge = "DefaultBadge-module--defaultBadge--2b65a";
export var setDefaultBadge = "DefaultBadge-module--setDefaultBadge--301f3";